class Responsive {
  constructor(bp) {
    this.minWidth = bp;
    this.currentWidth = window.innerWidth;
    this.mobile = this.currentWidth - this.minWidth;

    if (Math.sign(this.mobile) == -1) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }

    if (this.mobile) {
      this.toggleMobileStyles();
    }

    window.addEventListener('resize', this.updateOnResize.bind(this));
  }

  toggleMobileStyles() {
    let that = this;
    if (this.mobile) {
      document
        .querySelectorAll("*[id^='_desktop_']")
        .forEach(function (elm) {
          let target = document.getElementById(
            elm.id.replace('_desktop_', '_mobile_')
          );
          if (target) {
            that.swapChildren(elm, target);
          }
        });
    } else {
      document
        .querySelectorAll("*[id^='_mobile_']")
        .forEach(function (elm) {
          let target = document.getElementById(
            elm.id.replace('_mobile_', '_desktop_')
          );
          if (target) {
            that.swapChildren(elm, target);
          }
        });
    }
  }

  updateOnResize() {
    let _cw = this.currentWidth;
    let _mw = this.minWidth;
    let _w = window.innerWidth;

    let _toggle =
      (_cw >= _mw && _w < _mw) || (_cw < _mw && _w >= _mw);
    this.currentWidth = _w;
    this.mobile = this.currentWidth - this.min_width;
    if (_toggle) {
      this.toggleMobileStyles();
    }
  }

  swapChildren(obj1, obj2) {
    let obj1Content = obj1.innerHTML;
    let obj2Content = obj2.innerHTML;

    obj1.innerHTML = obj2Content;
    obj2.innerHTML = obj1Content;
  }
}

export default Responsive;
